import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Header,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import clone from 'clone';
import { flashErrorMessage } from '../../actions/flash';
import CloseSVG from '../../assets/icons/close.svg';
import {
  HIMS_DEVELOPER_CODE,
  HIMS_PROJECT_DEVELOPMENT_ID,
  HIMS_UNIT_FIELDS,
  HIMS_UNIT_NUMBER,
  HIMS_COMPONENT_ID,
  HIMS_LOT_PT,
  HIMS_LOT_POSITION,
  HIMS_LOT_POSITION_OPTIONS,
  HIMS_UNIT_MAIN_FIELDS,
} from '../../constants/hims';

class HIMSUnitSync extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    himsSetting: PropTypes.shape({
      himsDeveloperCode: PropTypes.string,
      himsDevelopmentCode: PropTypes.string,
    }),
    data: PropTypes.object,
    srUnits: PropTypes.array,
    unitCustomFieldSettings: PropTypes.array,
  }
  static getPropsToState = (props) => {
    const data = props.data;
    const srUnits = props.srUnits;
    const srUnitID = data.showroomUnitID;
    const himsUnitNo = data && data.showroomUnit && data.showroomUnit.projectUnitCustomFields && data.showroomUnit.projectUnitCustomFields.length > 0 &&
      data.showroomUnit.projectUnitCustomFields.find(pucf => pucf.projectUnitCustomFieldSettingID === HIMS_UNIT_NUMBER).value;
    return {
      data,
      srUnits,
      himsUnitNo,
      srUnitID,
    };
  }
  constructor(props) {
    super(props);
    const state = HIMSUnitSync.getPropsToState(props);
    this.state = {
      srUnitID: '',
      himsUnitNo: '',
      srUnits: [],
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = HIMSUnitSync.getPropsToState(nextProps);
    this.setState({
      ...state,
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  setHIMSFieldValue = (id) => {
    const { himsSetting } = this.props;
    const { data } = this.state;
    if (id === HIMS_DEVELOPER_CODE && himsSetting) {
      return himsSetting.himsDeveloperCode;
    }
    if (id === HIMS_PROJECT_DEVELOPMENT_ID && himsSetting) {
      return himsSetting.himsDevelopmentCode;
    }
    if (id === HIMS_UNIT_NUMBER) {
      return data.no_unit;
    }
    if (id === HIMS_COMPONENT_ID) {
      return data.pembangunan_id;
    }
    if (id === HIMS_LOT_PT) {
      return data.no_lot_pt;
    }
    if (id === HIMS_LOT_POSITION) {
      const lotPosition = HIMS_LOT_POSITION_OPTIONS.find(lp =>
        lp.text.toUpperCase() === data.kedudukan_lot ||
        lp.description.toUpperCase() === data.kedudukan_lot,
      );
      return lotPosition ? lotPosition.value : '';
    }
    return '';
  }
  checkUnitHasHimsFields = unit => unit.projectUnitCustomFields &&
    unit.projectUnitCustomFields.reduce((count, cf) => {
      if (
        HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID) &&
        cf.value
      ) {
        return count + 1;
      }
      return count;
    }, 0) === HIMS_UNIT_MAIN_FIELDS.length;
  handleOnConfirm = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { srUnits, srUnitID } = this.state;
    const { data, unitCustomFieldSettings } = this.props;
    if (!srUnitID) {
      store.dispatch(flashErrorMessage({
        header: 'Please fix form errors',
        message: 'Unit No. required',
      }));
    } else if (this.props.onConfirm) {
      const unitData = srUnits.find(unit => unit.id === srUnitID);
      const oldUnitData = srUnits.find(unit => unit.id === data.showroomUnitID);

      // set HIMS fields
      const newUnit = clone(unitData);
      const customFields = [];
      if (newUnit.projectUnitCustomFields) {
        newUnit.projectUnitCustomFields.forEach((p) => {
          if (HIMS_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
            p.value = this.setHIMSFieldValue(p.projectUnitCustomFieldSettingID);
          }
          customFields.push(p);
        });
      }
      if (unitCustomFieldSettings) {
        unitCustomFieldSettings.forEach((u) => {
          let exists = -1;
          if (newUnit.projectUnitCustomFields) exists = newUnit.projectUnitCustomFields.findIndex(ucfData => ucfData.projectUnitCustomFieldSettingID === u.id);
          if (exists === -1) {
            if (HIMS_UNIT_FIELDS.includes(u.id)) {
              const customField = {
                value: this.setHIMSFieldValue(u.id),
                projectUnitCustomFieldSettingID: u.id,
                projectUnitCustomFieldSetting: u,
              };
              customFields.push(customField);
            }
          }
        });
      }
      newUnit.projectUnitCustomFields = customFields;
      this.props.onConfirm(e, newUnit, oldUnitData);
    }
  }
  handleSelectUnit = (e, d) => {
    const { data } = this.state;
    this.setState({
      himsUnitNo: data.no_unit,
      srUnitID: d.value,
    });
  }
  renderHIMSTable() {
    const { data } = this.state;
    return (
      <Table celled fixed>
        <Table.Header>
          <Table.Row textAlign="center">
            <Table.HeaderCell colSpan="2">HIMS Unit List</Table.HeaderCell>
          </Table.Row>
          <Table.Row textAlign="center">
            <Table.HeaderCell>No. Unit</Table.HeaderCell>
            <Table.HeaderCell>No. Lot PT</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row textAlign="center">
            <Table.Cell>{data.no_unit}</Table.Cell>
            <Table.Cell>{data.no_lot_pt}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
  renderForm() {
    const { himsUnitNo, srUnitID, srUnits } = this.state;
    return (
      <div style={{ marginTop: '2em' }}>
        <Header as="h5" attached="top" textAlign="center" style={{ background: '#E9ECF0' }}>
          Showroom
        </Header>
        <Segment attached>
          <Form>
            <Form.Group widths="equal">
              <Form.Select
                fluid
                search
                label="Unit"
                name="unit_no"
                options={srUnits && srUnits.map(unit => ({
                  value: unit.id,
                  text: unit.reference,
                  icon: this.checkUnitHasHimsFields(unit) ? {
                    color: 'green',
                    name: 'checkmark',
                  } : null,
                }))}
                placeholder="Unit No."
                selectOnBlur={false}
                value={srUnitID || ''}
                onChange={this.handleSelectUnit}
              />
              <Form.Input
                name="hims_unit_no"
                label="HIMS Unit No."
                value={himsUnitNo || ''}
                placeholder="HIMS Unit No."
                readOnly
              />
            </Form.Group>
          </Form>
        </Segment>
      </div>
    );
  }
  render() {
    const { data } = this.state;
    return (
      <Modal
        className="himsModal"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        size="tiny"
      >
        <Modal.Header>
          <div className="modal_header">
            {`${data.showroomUnitID ? 'Edit' : 'Match'} Unit and Lot No.`}
            <Button
              basic
              className="closeButton"
              onClick={() => this.handleOnClose()}
            >
              <img src={CloseSVG} alt="close" />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description style={{ paddingBottom: '1em' }}>
            <div>
              <p style={{ marginBottom: '1.5em', color: '#596975' }}>
                Please ensure HIMS’s No. Unit and Showroom’s unit matches.
              </p>
              {this.renderHIMSTable()}
              {this.renderForm()}
            </div>
          </Modal.Description>
          <div style={{ marginTop: '1.5em', textAlign: 'right' }}>
            <Button
              basic
              style={{ marginRight: '1em' }}
              onClick={this.handleOnClose}
              content="Cancel"
            />
            <Button
              primary
              onClick={this.handleOnConfirm}
              content="Save"
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default HIMSUnitSync;



// WEBPACK FOOTER //
// ./src/containers/modals/HIMSUnitSync.jsx